import { api } from "@/lib/api";

// Haversine distance in km between two (lat,lng) points.
export function distanceKm(a, b) {
  if (!a || !b) return null;
  const R = 6371; // km
  const toRad = (v) => (v * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

export function formatDistance(km) {
  if (km == null || Number.isNaN(km)) return null;
  if (km < 1) return "nearby";
  if (km < 10) return `~${km.toFixed(1)} km`;
  return `~${Math.round(km)} km`;
}

export function geoSupported() {
  return typeof navigator !== "undefined" && "geolocation" in navigator;
}

export function getCurrentPosition(options = { enableHighAccuracy: false, timeout: 10000, maximumAge: 60000 }) {
  return new Promise((resolve, reject) => {
    if (!geoSupported()) return reject(new Error("Geolocation not supported"));
    navigator.geolocation.getCurrentPosition(resolve, reject, options);
  });
}

export async function shareLocation() {
  const pos = await getCurrentPosition();
  const payload = { lat: pos.coords.latitude, lng: pos.coords.longitude };
  await api.put("/profile/geo", payload);
  return payload;
}
